/**
 * Lead status category model.
 */
export default class LeadStatusCategory {
	/**
	 * Get all lead status categories.
	 * @returns {LeadStatusCategory[]}
	 */
	static getLeadStatusCategories(): LeadStatusCategory[] {
		return [
			LeadStatusCategory.createCategory(LeadStatusCategoryEnum.Pending),
			LeadStatusCategory.createCategory(LeadStatusCategoryEnum.Won),
			LeadStatusCategory.createCategory(LeadStatusCategoryEnum.Lost)
		];
	}

	static createCategory(category: string): LeadStatusCategory {
		switch (category) {
			case LeadStatusCategoryEnum.Pending:
				return new LeadStatusCategory("PENDING", LeadStatusCategoryEnum.Pending, "Pending");
			case LeadStatusCategoryEnum.Won:
				return new LeadStatusCategory("WON", LeadStatusCategoryEnum.Won, "Won");
			case LeadStatusCategoryEnum.Lost:
				return new LeadStatusCategory("LOST", LeadStatusCategoryEnum.Lost, "Lost");
		}
	}

	constructor(public readonly id: string, public readonly value: string, public readonly label: string) {}
}

export enum LeadStatusCategoryEnum {
	Pending = "PENDING",
	Won = "WON",
	Lost = "LOST"
}
